<template>
  <div>
    <section class="modal-card-body has-text-left">
      <step-tracker />
      <h2 class="step-heading" v-t="`${langRoot}.complete.title`" />
      <p data-ci="password-recovery-message" v-t="`${langRoot}.complete.helper`" />
    </section>

    <footer class="modal-card-foot">
      <div class="level">
        <div class="level-left">&nbsp;</div>

        <div class="level-right">
          <button @click="goToLogin" class="btn primary" v-t="`${langRoot}.complete.goToLoginBtn`" />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import StepTracker from './PasswordStepTracker';
import PageNotification from '@components/PageNotification';
import tracking from '@shared/mixins/tracking';

import { isEmpty } from 'lodash';
import { mapGetters } from 'vuex';

const name = 'passwordreset-complete';
export default {
    name,
    componentName: name,

    mixins: [tracking],

    props: {
        langRoot: { type: String, required: true },
    },

    components: {
        [PageNotification.name]: PageNotification,
        [StepTracker.name]: StepTracker,
    },

    data() {
        return {};
    },

    created() {
        if (isEmpty(this.questions)) {
            this.$router.replace({ name: 'Login' });
        }
    },

    computed: {
        ...mapGetters('passwordreset', ['getRecoveryQuestions']),
        questions() {
            return this.getRecoveryQuestions();
        },
    },

    methods: {
        goToLogin() {
            this.$trackEvent(this.pageTag, 'finish');
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// login/Components/PasswordResetComplete.vue